import React, { Component } from 'react';
import PropTypes from 'prop-types';
import './btns.scss';
import { GECKO_UTILS } from '../../';
import GeckoBtn from './btn.jsx';
import GeckoDropdown from '../dropdown/dropdown.jsx';
import { GeckoBtnsModel } from '../../models';

class GeckoBtns extends Component {
  isHidden(btn) {
    return btn.hideWhen ? btn.hideWhen() : false;
  }
  renderClasses() {
    return GECKO_UTILS.classNames({
      'gecko-btns': true,
      'btn-group': this.props.group,
    });
  }

  renderBtn(btn, i) {
    // If 'items' return a dropdown component
    if (this.isHidden(btn)) {
      return null;
    }
    if (btn.items && btn.items.length) {
      return (
        <GeckoDropdown
          name={btn.name}
          type={btn.type}
          icon={btn.icon}
          size={btn.size}
          preset={btn.preset}
          align={btn.align}
          items={btn.items}
          key={i}
        />
      );
    }
    return (
      <GeckoBtn
        className={btn.className}
        name={btn.name}
        type={btn.type}
        iconRight={btn.iconRight}
        icon={btn.icon}
        handler={btn.handler}
        size={btn.size}
        tooltip={btn.tooltip}
        preset={btn.preset}
        disabledWhen={btn.disabledWhen}
        hideWhen={btn.hideWhen}
        key={i}
      />
    );
  }

  render() {
    return (
      <div className={this.renderClasses()}>
        {this.props.items.map((btn, i) => this.renderBtn(btn, i))}
      </div>
    );
  }
}

GeckoBtns.defaultProps = {
  items: [],
  group: false,
};

GeckoBtns.propTypes = {
  items: GeckoBtnsModel,
  group: PropTypes.bool,
};

export default GeckoBtns;
